import { useStore } from "@xyflow/react";
import { useEffect } from "react";

/** Safari, and every iOS browser (all WebKit); not the Chromium-based ones. */
export const isWebKitUserAgent =
  typeof navigator !== "undefined" &&
  /AppleWebKit/.test(navigator.userAgent) &&
  !/Chrome|Chromium|Edg|CriOS/.test(navigator.userAgent);

/**
 * Marks `.react-flow` with `data-zoom-out` while the zoom is at or below
 * 100%, which promotes the viewport to one layer (canvas-styles.css): WebKit
 * then moves the nodes instead of repainting each one per pan frame. Never
 * above 100%, where WebKit would raster the layer at 1x and blur it. Mount
 * on WebKit only. Re-renders only when the zoom crosses 1.
 */
export function CanvasZoomOutLayer() {
  const zoomedOut = useStore((s) => s.transform[2] <= 1);
  const domNode = useStore((s) => s.domNode);
  useEffect(() => {
    if (!domNode) return;
    domNode.toggleAttribute("data-zoom-out", zoomedOut);
    return () => domNode.removeAttribute("data-zoom-out");
  }, [domNode, zoomedOut]);
  return null;
}
